import { throttle } from 'lodash';
import { useEffect, useRef } from 'react';

export const useScroll = (fn: () => any, throttleTime?: number) => {
    const dispose = useRef(() => {});
    useEffect(() => {
        if (fn) {
            if (throttleTime) {
                fn = throttle(fn, throttleTime);
            }
            window.addEventListener('scroll', fn);
            dispose.current = () => window.removeEventListener('scroll', fn);
            return dispose.current;
        }
    }, []);
    return dispose;
};
